import { getTypographyStyles, SEM_BORDER_RADIUS_UI_RADIUS_MAX, SEM_TYPOGRAPHY_FORMS_LABEL, SEM_TYPOGRAPHY_FORMS_LABEL_SMALL, SEM_TYPOGRAPHY_UI_MD_LABEL, SEM_TYPOGRAPHY_UI_XS_LABEL, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_25, SYS_SIZE_FIXED_500, SYS_SIZE_FIXED_600, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import styled, { css } from 'styled-components';
import { StyledCaptionHint } from './components/caption.js';
export const StyledListItem = styled.li `
  display: flex;
  position: relative;

  &:not(:last-child) {
    box-shadow: inset 0px -${SYS_SIZE_FIXED_25} 0px ${(props) => props.theme.sem.color.forms.foreground.divider.default};
  }

  ${(props) => props.custom &&
    css `
      padding: ${SYS_SPACE_FIXED_200};
    `}
`;
export const StyledHintText = styled.span `
  text-decoration: none;
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)};
  display: flex;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const StyledAvatar = styled.span `
  flex-shrink: 0;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border-radius: ${SEM_BORDER_RADIUS_UI_RADIUS_MAX};
  background-color: ${(props) => props.theme.cmp.color.ui.avatar.surface.fill.default};
  color: ${(props) => props.avatar?.variant === 'logged-in'
    ? props.theme.cmp.color.ui.avatar.foreground.text.secondary
    : props.theme.cmp.color.ui.avatar.foreground.icons.default};
  background-color: ${(props) => props.avatar?.variant === 'logged-in'
    ? props.theme.cmp.color.ui.avatar.surface.fill.default
    : 'transparent'};

  ${(props) => {
    if (props.avatar?.size === 'xs') {
        return css `
        height: ${SYS_SIZE_FIXED_600};
        width: ${SYS_SIZE_FIXED_600};
        ${getTypographyStyles(SEM_TYPOGRAPHY_UI_XS_LABEL)}
      `;
    }
    return css `
      height: ${SYS_SIZE_FIXED_1200};
      width: ${SYS_SIZE_FIXED_1200};
      ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_LABEL)}
    `;
}}
`;
export const LabelTextContainer = styled.span `
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  align-items: ${(props) => props.avatar?.size === 'sm' ? 'center' : 'flex-start'};
`;
export const StyledLabel = styled.div `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  padding: ${SYS_SPACE_FIXED_200};
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: ${SYS_SPACE_FIXED_100};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};

  svg {
    flex-shrink: 0;
  }

  ${(props) => !props.isDisabled &&
    css `
      &:hover,
      &:active,
      &:focus-within {
        ${StyledAvatar} {
          // TODO: token missing;
          transition-property: background-color;
          transition-duration: 250ms;
          transition-timing-function: ease;
          background-color: ${props.avatar?.variant === 'logged-in' &&
        props.theme.cmp.color.ui.avatar.surface.fill.pressed};

          color: ${props.avatar?.variant === 'logged-out' &&
        props.theme.cmp.color.ui.avatar.foreground.icons.pressed};
        }
      }
    `}

  ${(props) => (props.element === 'text' || props.element === 'link') &&
    css `
      align-items: flex-start;
    `}

    ${(props) => props.avatar &&
    css `
      align-items: center;
    `}

    ${(props) => (props.element === 'link' || props.element === 'input') &&
    !props.isDisabled &&
    css `
      cursor: pointer;
      // TODO: token missing;
      transition-property: background-color;
      transition-duration: 250ms;
      transition-timing-function: ease;

      &:hover,
      &:active {
        background-color: ${(props) => props.theme.cmp.color.forms.listItem.surface.fill.interactive};

        ${StyledHintText} {
          color: ${props.theme.sem.color.forms.foreground.icons.interactive};
        }
      }
    `}

      ${(props) => props.isDisabled &&
    css `
      cursor: not-allowed;
      color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};

      ${StyledHintText} {
        color: ${(props) => props.theme.sem.color.forms.foreground.icons.disabled};
      }

      ${StyledCaptionHint} {
        color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
      }

      ${StyledAvatar} {
        background-color: ${props.avatar?.variant === 'logged-in' &&
        props.theme.cmp.color.ui.avatar.surface.fill.disabled};

        svg {
          color: ${(props) => props.theme.cmp.color.ui.avatar.foreground.icons.disabled};
        }
      }
    `}

    ${(props) => props.element === 'input' &&
    css `
      padding: ${SYS_SPACE_FIXED_200}
        ${props.variant === 'toggle'
        ? `calc(${SYS_SIZE_FIXED_1400} + ${SYS_SPACE_FIXED_200} + ${SYS_SPACE_FIXED_100})`
        : `calc(${SYS_SIZE_FIXED_500} + ${SYS_SPACE_FIXED_200} + ${SYS_SPACE_FIXED_100})`}
        ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_200};
    `};

  ${(props) => props.element === 'text' &&
    css `
      ${StyledHintText} {
        svg {
          color: ${(props) => props.theme.sem.color.forms.foreground.icons.default};
        }
      }
    `}
`;
export const StyledInputContainer = styled.div `
  position: absolute;
  right: ${SYS_SPACE_FIXED_200};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
`;
//# sourceMappingURL=index.styles.js.map